var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8001 4.79999C8.8001 5.43651 8.54724 6.04696 8.09715 6.49705C7.64707 6.94714 7.03662 7.19999 6.4001 7.19999C5.76358 7.19999 5.15313 6.94714 4.70304 6.49705C4.25295 6.04696 4.0001 5.43651 4.0001 4.79999C4.0001 4.16347 4.25295 3.55303 4.70304 3.10294C5.15313 2.65285 5.76358 2.39999 6.4001 2.39999C7.03662 2.39999 7.64707 2.65285 8.09715 3.10294C8.54724 3.55303 8.8001 4.16347 8.8001 4.79999ZM11.2001 13.6C11.2001 12.327 10.6944 11.1061 9.79421 10.2059C8.89404 9.30571 7.67314 8.79999 6.4001 8.79999C5.12706 8.79999 3.90616 9.30571 3.00599 10.2059C2.10581 11.1061 1.6001 12.327 1.6001 13.6H11.2001ZM10.4001 6.39999C10.1879 6.39999 9.98444 6.48428 9.83441 6.63431C9.68438 6.78434 9.6001 6.98782 9.6001 7.19999C9.6001 7.41217 9.68438 7.61565 9.83441 7.76568C9.98444 7.91571 10.1879 7.99999 10.4001 7.99999H13.6001C13.8123 7.99999 14.0158 7.91571 14.1658 7.76568C14.3158 7.61565 14.4001 7.41217 14.4001 7.19999C14.4001 6.98782 14.3158 6.78434 14.1658 6.63431C14.0158 6.48428 13.8123 6.39999 13.6001 6.39999H10.4001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRemove);
export default __webpack_public_path__ + "static/media/UserRemove.12b121cc28f1b914839070552fc0384e.svg";
export { ForwardRef as ReactComponent };